import "./CarouselExperienceRewards.scss";
import "swiper/css";
import { Navigation, Pagination } from "swiper/modules";
import { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper as SwiperType } from "swiper";
import { EnumIcon } from "../../models/enumIcon";
import SimpleCard from "../SimpleCard/SimpleCard";
import { useComponentVisible } from "../../utils/useDeviceSize";
import locale from "../../assets/locale.json";
import usePrizes from "../../utils/usePrizes";
import { environment } from "../../environment/environment";
import { Link } from "react-router-dom";
import serialize from "../RichText/RichText";
import Button from "../Button/Button";

const CarouselExperienceRewards = () => {
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const swiperRef = useRef<SwiperType>();
  const { isMobile } = useComponentVisible();
  const { prizes } = usePrizes();

  if (prizes && prizes.experiences.length === 1) {
    return(
      <div>
        <h2 className="pw-carousel-experience-subtitle">
          {locale.discover_prize_section.carousel_experience_title}
        </h2>
        { prizes.experiences.map((card, index) => (
          <div 
            key={index}
            className={`pw-simple-card-container experience-with-background ${card.className || ""}`}
            style={{
              backgroundImage: `url(${environment.apiImage + "/" + card.image.filename})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              position: 'relative',
              height: 'auto',
              minHeight: '400px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end'
            }}
          >
            <div className="overlay-gradient"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              height: '100%',
              width: '100%',
              background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))',
            }}
            ></div>
            <div className="pw-simple-card-content" style={{zIndex: 1,}}>
              {card.note && (
                <p className="pw-simple-card-note sub-paragraph" style={{color: 'white'}}>
                  {serialize(card.note)}
                </p>
              )}
              <h2 className="paragraph-semi-bold-medium pw-simple-card-title" style={{color: 'white'}}>
                {card.title}
              </h2>
              <p className="pw-simple-card-description paragraph" style={{color: 'white'}}>
                {serialize(card.shortDescription)}
              </p>
              <div style={{ display: "flex", width: "100%", marginTop: 24 }}>
                <Button
                  className={
                    "pw-simple-card-button-white"
                  }
                  label={locale.simple_card.action_button_label}
                  theme="white"
                  onClick={() => window.location.href = `/experience/${card.id}`}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="pw-carousel-experience-container">
      <div className="pw-carousel-experience-button-container">
        <h2 className="pw-carousel-experience-subtitle">{locale.discover_prize_section.carousel_experience_title}</h2>
        <div className="pw-carousel-experience-button">
          <button
            disabled={currentSlide === 0}
            className={`pw-carousel-experience-navigation`}
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <i className={`${EnumIcon.goBack} pw-navigation-icon`} />
          </button>
          <button
            disabled={prizes && (
              isMobile
                ? currentSlide === prizes.experiences.length - 1
                : currentSlide === prizes.experiences.length - 2
            )}
            className={`pw-carousel-experience-navigation`}
            onClick={() => swiperRef.current?.slideNext()}
          >
            <i className={`${EnumIcon.goAhead} pw-navigation-icon`} />
          </button>
        </div>
      </div>
      <Swiper
        modules={[Navigation, Pagination]}
        onBeforeInit={(swiper: any) => {
          swiperRef.current = swiper;
        }}
        slidesPerView="auto"
        breakpoints={{
          769: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
        }}
        pagination={{
          el: ".custom-pagination",
          clickable: true,
        }}
        onSlideChange={(swiper: SwiperType) =>
          setCurrentSlide(swiper.activeIndex)
        }
        spaceBetween={24}
      >
        {prizes &&
          prizes.experiences.map((card, index) => (
            <SwiperSlide key={index}>
              <div className="pw-simple-card-carousel-reward">
                <SimpleCard {...card} path={`/experience/${card.id}`} />
              </div>
            </SwiperSlide>
          ))}
      </Swiper>
      <div className="custom-pagination"></div>
    </div>
  );
};

export default CarouselExperienceRewards;
